<template>
  <div>
    <content-loader v-if="$apollo.loading" title="perk details" />
    <div v-else>
      <page-header :title="perk.name"></page-header>
      <div class="container">
        <div class="card mt-4 mb-4">
          <div class="card-body">
            <span
              class="badge badge-pill badge-info"
              v-for="tag in perk.tags"
              :key="tag"
              >{{ tag }}</span
            >
            <company-card :company="perk.company"></company-card>
            <h4 class="card-title">{{ perk.name }}</h4>
            <p class="card-text">{{ perk.description }}</p>
            <button @click="claimPerk" class="btn btn-primary">
              Claim now
            </button>
          </div>
        </div>
      </div>
      <b-modal
        title="Use Perk"
        id="perk-claim-modal"
        ok-title="Done"
        ok-only
        @ok="submit()"
      >
        <div v-if="perk.claimType == 'LINK'">
          <p>To use this perk:</p>
          <ul>
            <li>
              Visit
              <a :href="perk.claimUrl" target="_blank">{{ perk.claimUrl }}</a
              >.
            </li>
            <li>No code is required.</li>
          </ul>
        </div>
        <div v-if="perk.claimType == 'CODE'">
          <p>To use this perk:</p>
          <ul>
            <li>
              Visit
              <a :href="perk.claimUrl" target="_blank">{{ perk.claimUrl }}</a
              >.
            </li>
            <li>Use the code "{{ perk.claimCode }}" during checkout.</li>
          </ul>
        </div>
        <div v-if="perk.claimType == 'ENQUIRY'">
          <p>
            To use this perk, please confirm your contact details. We will share
            these with the perk provider ({{ perk.company.name }}), and a member
            of their team will contact you soon.
          </p>
          <form class="mb-3" v-if="user">
            <div class="form-group">
              <label for="name">Name</label>
              <input
                type="text"
                name="name"
                :value="user.name"
                class="form-control"
              />
            </div>
            <div class="form-group">
              <label for="email">Work Email</label>
              <input
                type="text"
                name="email"
                :value="user.email"
                class="form-control"
              />
            </div>
            <div class="form-group">
              <label for="company">Company Name</label>
              <input
                type="text"
                name="company"
                :value="user.company.name"
                class="form-control"
              />
            </div>
          </form>
        </div>
      </b-modal>
    </div>
  </div>
</template>

<script>
import CodeClaim from '@/components/perks/CodeClaim';
import EnquiryClaim from '@/components/perks/EnquiryClaim';
import GetPerk from '@/gql/GetPerkDetail.gql';
import ContentLoader from '@/components/global/ContentLoader';
import PageHeader from '@/components/global/PageHeader';
import CompanyCard from '@/components/company/CompanyCard';
import $auth from '@/services/auth.js';

export default {
  name: 'perk-detail',

  components: {
    PageHeader,
    ContentLoader,
    CodeClaim,
    EnquiryClaim,
    CompanyCard
  },
  data() {
    return {
      loggedIn: false,
      user: null
    };
  },
  apollo: {
    perk: {
      query: GetPerk,
      variables() {
        return {
          id: this.$route.params.id
        };
      }
    }
  },
  async beforeCreate() {
    var user = await $auth.user();
    if (user) {
      this.loggedIn = true;
      this.user = user;
    }
  },
  methods: {
    submit() {
      console.log('You claimed something');
    },
    claimPerk() {
      if (this.loggedIn) {
        this.$bvModal.show('perk-claim-modal');
      } else {
        alert('Please sign-in to claim this perk');
        this.$router.push({ name: 'Login' });
      }
    }
  }
};
</script>

<style scoped>
img {
  max-width: 100%;
  width: 50px;
  margin-bottom: 10px;
}
.badge {
  float: right;
}
a.btn {
  color: #ffffff;
}
</style>
